import { createSlice } from "@reduxjs/toolkit";
import { translate } from "../utils/language";

export const generateName = (category, categories) => {
    if (!category) return '';

    let categoryName = category.label;
    if (category.parentId) {
        const parent = categories[category.parentId];
        if (parent) {
            categoryName = `${generateName(parent, categories)} - ${categoryName}`;
        }
    }
    return categoryName;
}
export function sortCategoriesByParentId(categories) {
    const categoryArray = Object.values(categories)
    const newCategoryObject = {

    }
    categoryArray?.forEach(category => {
        const name = generateName(category, categories)
        newCategoryObject[category?.value] = { ...category, label: name }
    })
    return newCategoryObject
}

const themeSlice = createSlice({
    name: "theme",
    initialState: {
        attributes: [],
        stockLocations: [],
        themeId: null,
        editItemId: null,
        editItemData: null,
        currentComponentId: null,
        currentBeforeAfterComponentId: null,
        componentProps: null,
        currentHoverComponentId: null,
        initialSelectedOptions: {
            targetKey: "",
            key: "",
            index: 0,
            onlyOneCategory: false
        },
        currentPageId: null,
        currentSectionId: null,
        deletedItems: [],
        copiedItemId: "",
        copiedItem: null,
        icons: [],
        iconTypes: [],
        branding: {},
        products: {},
        categories: {},
        brands: {},
        pages: [],
        pagesWithoutSections: [],
        imageHashMap: {},
        stringifiedOnLoadThemeData: "",
        staticValues: [],
        settings: {
            isWebView: false
        },
        collectionHashMap: {},
        activeMenuId: null,
        themeLicense: null,
        selectedProduct: null
    }
    ,
    reducers: {
        setEditItemId: (state, action) => {
            const payload = action.payload
            state.editItemId = payload
        },
        setEditItemData: (state, action) => {
            const payload = action.payload
            state.editItemData = payload
        },
        setCurrentComponentId: (state, action) => {
            const payload = action.payload
            state.currentComponentId = payload
        },
        setCurrentBeforeAfterComponentId: (state, action) => {
            const payload = action.payload
            state.currentBeforeAfterComponentId = payload
        },
        setComponentProps: (state, action) => {
            const payload = action.payload
            state.componentProps = payload
        },
        setCurrentHoverComponentId: (state, action) => {
            const payload = action.payload
            state.currentHoverComponentId = payload
        },
        setIcons: (state, action) => {
            const payload = action.payload
            state.icons = payload
        },
        setIconsTypes: (state, action) => {
            const payload = action.payload
            state.iconTypes = payload
        },
        setBranding: (state, action) => {
            const payload = action.payload
            state.branding = payload
        },
        setGeneralStyle: (state, action) => {
            if (!state.branding.generalStyle) {
                state.branding.generalStyle = {}
            }
            state.branding.generalStyle = action.payload
        },
        setProducts: (state, action) => {
            const payload = action.payload
            state.products = { ...state.products, ...payload }
        },
        clearCollection: (state, action) => {
            state.categories = {}
            state.brands = {}
        },
        setCategories: (state, action) => {
            const payload = action.payload
            state.categories = { ...state.categories, ...payload }
        },
        setCategoriesWithParentId: (state, action) => {
            const categories = state.categories
            const convertedCategories = sortCategoriesByParentId(categories)
            state.categories = convertedCategories
        },
        setBrands: (state, action) => {
            const payload = action.payload
            state.brands = { ...state.brands, ...payload }
        },
        setInitialSelectedOptions: (state, action) => {
            const payload = action.payload
            if (!payload) return null
            state.initialSelectedOptions = payload
        },
        setCurrentSectionId: (state, action) => {
            const payload = action.payload
            state.currentSectionId = payload
        },
        setCurrentPageId: (state, action) => {
            const payload = action.payload
            state.currentPageId = payload
        },
        resetDeletedItems: (state) => {
            state.deletedItems = {}
        },
        saveDeletedItems: (state, action) => {
            const payload = action.payload
            const activeThemePageId = payload.activeThemePageId
            const item = payload.item
            const currentDeletedItems = state.deletedItems[activeThemePageId]
            if (currentDeletedItems) {
                state.deletedItems[activeThemePageId] = [...state.deletedItems[activeThemePageId], item]
                return
            }

            state.deletedItems[activeThemePageId] = [item]
        },
        undoLastItem: (state, action) => {
            const activeThemePageId = action.payload
            if (!activeThemePageId) return
            const activeDeletedItems = state.deletedItems[activeThemePageId]
            if (!activeDeletedItems) return
            const newState = [...activeDeletedItems]
            newState.pop()
            state.deletedItems[activeThemePageId] = newState
        },
        setCopiedItem: (state, action) => {
            const payload = action.payload
            if (!payload) return
            state.copiedItem = structuredClone(payload)
        },
        setImageHashMap: (state, action) => {
            const newState = action.payload
            state.imageHashMap = { ...state.imageHashMap, ...newState }
        },
        setCollectionHashMap: (state, action) => {
            const newState = action.payload
            state.collectionHashMap = { ...state.collectionHashMap, ...newState }
        },
        setPages: (state, action) => {
            try {
                const payload = structuredClone(action.payload)
                const pagesWithoutSections =
                    payload &&
                    Object.values(payload)?.map(page => {
                        const isReservedName = page?.isReservedName;

                        return {
                            customPageType: page?.customPageType,
                            value: page?.id,
                            label: isReservedName ? translate(page?.name) : page?.name,
                            isReservedName,
                            data: {
                                id: page?.id,
                                type: 'page',
                            },
                            type: 'page',
                        };
                    });

                state.pagesWithoutSections = pagesWithoutSections
                const pages =
                    payload &&
                    Object.values(payload)?.map(page => {
                        const isReservedName = page?.isReservedName;
                        if (!isReservedName || page?.id === 'Main') {
                            return page?.sections?.map(section => {
                                return {
                                    customPageType: page?.customPageType,
                                    value: page?.id + ';' + section?.id,
                                    label: isReservedName
                                        ? translate(page?.name) + ' - ' + section?.name
                                        : page?.name + ' - ' + section?.name,
                                    isReservedName,
                                    data: {
                                        id: page?.id + ';' + section?.id,
                                        type: 'page',
                                    },
                                    type: 'page',
                                };
                            });
                        }
                        return {
                            customPageType: page?.customPageType,
                            value: page?.id,
                            label: isReservedName ? translate(page?.name) : page?.name,
                            isReservedName,
                            data: {
                                id: page?.id,
                                type: 'page',
                            },
                            type: 'page',
                        };
                    });
                state.pages = pages.flat(2)
            } catch {

            }
        },
        setStringifiedOnLoadThemeData: (state, action) => {
            const payload = action.payload
            state.stringifiedOnLoadThemeData = payload
        },
        setStaticValues: (state, action) => {
            state.staticValues = action.payload || []
        },
        setSettings: (state, action) => {
            state.settings = action.payload || {}
        },
        setThemeId: (state, action) => {
            state.themeId = action.payload || {}
        },
        setActiveMenuId: (state, action) => {
            state.activeMenuId = action.payload
        },
        setThemeLicense: (state, action) => {
            state.themeLicense = action.payload
        },
        setAttributes: (state, action) => {
            state.attributes = action.payload
        },
        setStockLocations: (state, action) => {
            state.stockLocations = action.payload
        },
        setSelectedProduct: (state, action) => {
            state.selectedProduct = action.payload
        },
    },
});

export default themeSlice;
